import { ApplicationSetting } from '@app/core/model/enums/application-setting.enum'
import { Preference } from '@app/core/model/user-preferences.interface'
import { User } from '@app/core/model/user.model'
import { ScopeComponent } from '@app/features/scoping/models/component.model'
import { ScopeVersion } from '@app/core/model/scope-version'
import { TableColumnKey } from '../../ui-components/scope-ui-table/table-column-key.enum'
import { isNil } from 'lodash'
import { DEFAULT_PLACEHOLDER } from '@app/shared/constants/default-placeholder.const'

export const getMainComponentColumns = (currentScope: ScopeVersion, user: User): Preference[] => [
  {
    key: TableColumnKey.COMPONENT_NAME,
    name: 'COMPONENT',
    selected: true,
    isVisibleInList: () => false,
    value: (component: ScopeComponent) =>
      component.name && component.name.length > 0 ? component.name : component.source.name,
  },
  {
    key: TableColumnKey.SIZE,
    name: 'Size',
    selected: true,
    field: 'complexity',
    requiredSetting: 'COMPONENT_SIZES__ENABLE',
  },
  {
    key: TableColumnKey.QUANTITY_MODIFIER,
    name: `Quantity Modifier`,
    selected:
      currentScope.isScopeByScenario() &&
      !user.company.hasApplicationSetting(ApplicationSetting.COMPONENT__ENABLE_FRACTIONAL_QUANTITIES),
    value: (entity: ScopeComponent) =>
      !isNil(entity.quantityModifier) && entity.quantityModifier !== 1 ? entity.quantityModifier : DEFAULT_PLACEHOLDER,
    isVisibleInList: () =>
      currentScope.isScopeByScenario() &&
      !user.company.hasApplicationSetting(ApplicationSetting.COMPONENT__ENABLE_FRACTIONAL_QUANTITIES),
  },
  {
    key: TableColumnKey.PRICE_MODIFIER,
    name: `Price Modifier`,
    selected: currentScope.isScopeByScenario(),
    value: (entity: ScopeComponent) =>
      !isNil(entity.priceModifier) && entity.priceModifier !== 1 ? entity.priceModifier : DEFAULT_PLACEHOLDER,
    isVisibleInList: () => currentScope.isScopeByScenario(),
  },
]
